import React, {Component} from 'react';
import objeler from '../objeler';
import Colorpicker from '../Colorpicker';
import ComboBox from "./ComboBox";
import Button from '@material-ui/core/Button';
import DialogStyles from '../ModalDialog/DialogStyles'
import {withStyles} from '@material-ui/core/styles';
import 'react-dropdown/style.css'
import './modal.css'
import axios from 'axios';
import StructuredBindingPanel from './StructuredBindingPanel';

const fontItems = require('../../items/fontitems.json');
const borderStyleItems = require('../../items/BorderStyle.json');
const directionItems = require('../../items/Directions.json');

class PictureProperties extends Component {
    options = [
        '6', '7', '8', '9'
    ];
    defaultOption = this.options[0];

    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.state = {
            activeFontFamily: "Open Sans",
            activeBold: "false",
            picFile: "",
            certFile: "",
        };
        this.onChange = this.onChange.bind(this)
        this.onChangeCert = this.onChangeCert.bind(this)
        this.state = {
            imageURL: '',
        };
        this.handleUploadImage = this.handleUploadImage.bind(this);
    };

    async handleUploadImage(ev) {
        ev.preventDefault();
        const data = new FormData();
        data.append('file', this.uploadInput.files[0]);
        data.append('filename', this.fileName.value);

        await fetch('http://localhost:8000/upload', {
            method: 'POST',
            body: data,
        }).then((response) => {
            response.json().then((body) => {
                this.setState({imageURL: `http://localhost:8000/${body.file}`});
            });
        });
    }

    componentDidMount() {
        setTimeout(() => {
            try {
                this.child.select();
            } catch {
            }
            ;
        }, 1);
    }

    updateInputValue(e) {
        objeler.tarik.Text = e.target.value;
    }

    changeColor = (clr, event) => {
        objeler.tarik.Color = clr.hex;
    };
    changeBgColor = (clr, event) => {
        objeler.tarik.BColor = clr.hex;
    };

    onBorderWidthChage(e) {
        this.setState({value: e.target.value});
        if(objeler.ElementProps) objeler.ElementProps.BorderWidth = e.target.value;
    }

    onFontChage(e) {
        this.setState({value: e.target.value, text: e.target[e.target.selectedIndex].text});
        objeler.tarik.Font = e.target.value;
        objeler.tarik.FontFamily = e.target[e.target.selectedIndex].text;
    }

    onBorderStyleChage(e) {
        this.setState({value: e.target.value});
        if(objeler.ElementProps) objeler.ElementProps.BorderStyle = e.target.value;
    }

    onDirectionChage(e) {
        this.setState({value: e.target.value});
        if(objeler.ElementProps) objeler.ElementProps.Direction = e.target.value;
    }

    onFillColorChage = (clr, event) => {
        objeler.tarik.FillColor = clr.hex;
    };
    onBorderColorChage = (clr, event) => {
        objeler.tarik.BorderColor = clr.hex;
    };

    onChangeBold(e) {
        if(objeler.ElementProps) objeler.ElementProps.Bold = e.target.checked;
    }

    onChangeFill(e) {
        if(objeler.ElementProps) objeler.ElementProps.Fill = e.target.checked;
    }

    onChangeItalic(e) {
        if(objeler.ElementProps) objeler.ElementProps.Italic = e.target.checked;
    }

    onPasswordChage(e) {
        objeler.tarik.Password = e.target.value;
    }

    onFontSizeChage(e) {
        this.setState({FontSize: e.target.value})
        objeler.tarik.FontSize = e.target.value;
        if(objeler.ElementProps) objeler.ElementProps.FontSize = e.target.value;
        if(objeler.ElementProps) console.log("objeler.ElementProps.FontSize", objeler.ElementProps.FontSize);
    }

    onChangeCert(e) {
        this.setState({certFile: e.target.files[0].name});
        objeler["certFile"] = e.target.files[0];
        if(objeler.ElementProps) objeler.ElementProps.CertFileName = e.target.files[0].name;
        if(objeler.ElementProps) objeler.ElementProps.CertBlob = window.URL.createObjectURL(e.target.files[0]);
        return;
    }

    onChange(e) {
        this.setState({picFile: e.target.files[0].name});
        objeler["picFile"] = e.target.files[0];
        if(objeler.ElementProps) objeler.ElementProps.JpgFileName = e.target.files[0].name;
        if(objeler.ElementProps) objeler.ElementProps.JpgBlob = window.URL.createObjectURL(e.target.files[0]);
        return;
        console.log(e.target.files[0]);
        if(objeler.ElementProps) objeler.ElementProps.JpgFileName = e.target.files[0].name;
        const data = new FormData();
        data.append('file', e.target.files[0]);
        data.append('filename', e.target.files[0].name);


        fetch('http://localhost:8000/upload', {
            method: 'POST',
            body: data,
        }).then((response) => {
            console.log(response);
            response.json().then((body) => {
                this.setState({imageURL: `http://localhost:8000/${body.file}`});
                console.log(body.file);
                if(objeler.ElementProps) objeler.ElementProps.Jpg = "http://localhost:8000/" + body.file;
                if(objeler.ElementProps) objeler.ElementProps.JpgPath = objeler.ElementProps.Jpg;
            });
        }).catch(errors => console.log(errors));
        ;
        return;
        let formdata = new FormData();
        formdata.append('file', './test.jpg');
        alert(e.target.value);
        fetch('http://localhost:3000/upload/', {
            method: 'PUT',
            body: formdata,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'image/jpeg',
            },
        })
            .then(response => console.log(response))
            .catch(errors => console.log(errors));
        return;
        let formData = new FormData();
        formData.append('file', e.target.value);
        console.log('>> formData >> ', formData);

        // You should have a server side REST API
        axiosInstance.post('http://127.0.0.1:3000/',
            formData, {
                headers: {
                    'Content-Type': 'image/jpeg'
                }
            }
        ).then(function () {
            console.log('SUCCESS!!');
        })
            .catch(function () {
                console.log('FAILU RE!!');
            });
    }

    onStructuredBindingChange = (binding) => {
        if (!objeler.ElementProps) return;

        objeler.ElementProps.binding = binding;
        if (objeler.ElementProps.Object) {
            objeler.ElementProps.Object.binding = binding;
            objeler.ElementProps.Object.properties = {
                ...(objeler.ElementProps.Object.properties || {}),
                binding
            };
        }

        this.forceUpdate();
    }

    render() {
        const http = require("http");
        const fontStyles = {
            values: [
                {
                    name: 'Regular',
                    value: 'Regular',
                },
                {
                    name: 'Bold',
                    value: 'Bold',
                },
                {
                    name: 'Italic',
                    value: 'Italic',
                },
                {
                    name: 'Bold Italic',
                    value: 'BoldItalic',
                },
            ],
            value: '?',
        };
        const {t, color, backgroundColor, type} = this.props;
        const prp = objeler["tarik"];
        const trStyle = {
            borderWidth: "1px",
        };
        const tdStyle = {
            color: "Black",
            textAlign: "left",
            valign: "bottom"
        };
        const pStyle = {
            height: "56px",
            color: "#000000",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden',
            textAlignVertical: 'top',
            marginTop: '5px',
            whiteSpace: 'nowrap'
        };
        const fStyle = {
            left: "60px",
            float: "right",
            position: "absolute",
            color: "#000000",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const tableStyle = {
            left: "47px",
            width: "100%",
            height: "100%",
            zIndex: "6"
        };
        const textStyle = {
            display: "block",
            width: "100%",
            height: "25px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const divStyle = {
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const passwordStyle = {
            display: "block",
            width: "100%",
            height: "25px",
            zIndex: "0"
        };
        const fileTextStyle = {
            display: "block",
            width: "100%",
            height: "25px",
            zIndex: "0",
            marginTop: "3px",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const fontSizeStyle = {
            width: "60px",
            height: "25px",
            borderWidth: "1px",
            textAlignVertical: "middle",
            marginTop: "0px",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
            , textAlign: 'center'
        };
        const borderSizeStyle = {
            width: "60px",
            height: "24px",
            borderWidth: "1px",
            textAlignVertical: "middle",
            marginTop: "0px",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
            , textAlign: 'center'
        };
        const browseTextStyle = {
            display: "block",
            width: "70px",
            height: "25px",
            zIndex: "0",
            marginTop: "11px",
            fontSize: "12px",
            justifyContent: 'center',
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const dataSourceStyle = {
            display: "block",
            width: "100px",
            height: "25px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const conditionStyle = {
            display: "block",
            width: "200px",
            height: "65px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const comboStyle = {
            display: "block",
            width: "100%",
            height: "25px",
            zIndex: "0",
            vAlign: "middle",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const borderStyleStyle = {
            display: "block",
            width: "100px",
            height: "25px",
            zIndex: "0",
            vAlign: "middle",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const borderStyleStyle70 = {
            display: "block",
            width: "70%",
            height: "25px",
            zIndex: "0",
            vAlign: "middle",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const hidden = {
            display: "none"
        };
        const {classes} = this.props;
        return (
            <div style={divStyle}>
                <table style={tableStyle} id="Table1">
                    <tbody>
                    <tr>
                        {(() => {
                            switch (type) {
                                case "Signature":
                                    return (
                                        <React.Fragment>
                                            <td className="cell0"><p style={pStyle}>&nbsp;Text : </p></td>
                                            <td className="cell1">
                          <textarea name="TextArea1" id="TextArea1"
                                    ref={abc => this.child = abc}
                                    defaultValue={(objeler.ElementProps || {}).Text || ""}
                                    onChange={this.updateInputValue}
                                    style={textStyle} rows="1" cols="20" spellCheck="false">
                          </textarea>
                                            </td>
                                            <td className="cell0"><p style={pStyle}>&nbsp;Image : </p></td>
                                            <td className="cell1">
                                                <table
                                                    style={{border: "1px"}, {borderStyle: "solid"}, {borderColor: "black"}}
                                                    id="Table1">
                                                    <tbody>
                                                    <tr>
                                                        <td className="cell1" style={{height: "10px"}}>
                                                            <input id="picFile" className="form-control" type="text"
                                                                   readOnly="true" style={fileTextStyle}
                                                                   value={(objeler.ElementProps || {}).JpgFileName || ""}
                                                            />
                                                        </td>
                                                        <td className="cellbtn" style={{height: "10px"}}>
                                                            <form onSubmit={this.onFormSubmit}>
                                                                <label htmlFor="file-upload"
                                                                >
                                                                    <Button variant="raised" component="span"
                                                                            style={{width: '5em', paddingLeft: '.75em'}}
                                                                            className={classes.browseButton}
                                                                    >Browse </Button>
                                                                </label>
                                                                <input id="file-upload" type="file"
                                                                       onChange={this.onChange}
                                                                       style={{display: "none"}} accept="image/*"/>
                                                            </form>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </React.Fragment>
                                    )
                                case "Lines":
                                case "Rectangle":
                                case "Ellipse":
                                    return (
                                        < React.Fragment>
                                            <table style={tableStyle} id="Table1">
                                                <tbody>
                                                <tr>
                                                    <td className="cell0"><p style={pStyle}>Border Style:</p></td>
                                                    <td className="cell1">
                                                        <div style={{whiteSpace: 'nowrap', display: 'inline-flex'}}>
                                                            <ComboBox onChange={e => this.onBorderStyleChage(e)}
                                                                      comboStyle={borderStyleStyle}
                                                                      comboValue={(objeler.ElementProps || {}).BorderStyle || "Solid"}
                                                                      items={borderStyleItems}/>
                                                            <input
                                                                style={borderSizeStyle}
                                                                type="number"
                                                                onKeyDown={e => e.preventDefault()}
                                                                min="1" max="50 "
                                                                value={(objeler.ElementProps || {}).BorderWidth || 1}
                                                                onChange={e => this.onBorderWidthChage(e)}/>
                                                        </div>
                                                    </td>
                                                    <td className="cell0"><p style={pStyle}>Border Color:</p></td>
                                                    <td className="cell1">
                                                        <Colorpicker color={prp&&prp.Object&&prp.Object.properties ? prp.Object.properties.BorderColor : "#000000"}
                                                                     onChangeCompleted={this.onBorderColorChage}/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="cell0">
                                                        <div id="wb_Checkbox1">
                                                            <input type="checkbox" id="chkFill" name=""
                                                                   style={{display: "inline-block"}}
                                                                   onChange={e => this.onChangeFill(e)}
                                                                   defaultChecked={(objeler.ElementProps || {}).Fill || false}/>
                                                            <label htmlFor="Checkbox1"
                                                                   style={{left: "60px"}, {float: "right"}, {position: "absolute", fontSize: "14px", fontFamily: 'Raleway, Arial'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fill</label>
                                                        </div>
                                                    </td>
                                                    <td className="cell1"></td>
                                                    <td className="cell0"><p style={pStyle}>Fill Color:</p>
                                                    </td>
                                                    <td className="cell1">
                                                        <Colorpicker color={prp&&prp.Object&&prp.Object.properties ? prp.Object.properties.FillColor : "#FFFFFF"}
                                                                     onChangeCompleted={this.onFillColorChage}/>
                                                    </td>
                                                    <td className="cell0"><p
                                                        style={type == "Lines" ? pStyle : hidden}>Direction:</p></td>
                                                    <td>
                                                        <br></br>
                                                        <ComboBox onChange={e => this.onDirectionChage(e)}
                                                                  comboStyle={type == "Lines" ? borderStyleStyle70 : hidden}
                                                                  comboValue={(objeler.ElementProps || {}).Direction || "Horizontal"}
                                                                  items={directionItems}/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </React.Fragment>
                                    )
                                default:
                                    return (
                                        <React.Fragment>
                                            <td className="cell0"><p style={pStyle}>&nbsp;Image : </p></td>
                                            <td className="cell1">
                                                <table
                                                    style={{border: "1px"}, {borderStyle: "solid"}, {borderColor: "black"}}
                                                    id="Table1">
                                                    <tbody>
                                                    <tr>
                                                        <td className="cell1" style={{height: "10px"}}>
                                                            <input id="picFile" className="form-control" type="text"
                                                                   readOnly="true" style={fileTextStyle}
                                                                   value={(objeler.ElementProps || {}).JpgFileName || ""}
                                                            />
                                                        </td>
                                                        <td className="cellbtn" style={{height: "10px"}}>
                                                            <form onSubmit={this.onFormSubmit}>
                                                                <label htmlFor="file-upload"
                                                                >
                                                                    <Button variant="raised" component="span"
                                                                            style={{width: '5em', paddingLeft: '.75em'}}
                                                                            className={classes.browseButton}
                                                                    >Browse </Button>
                                                                </label>
                                                                <input id="file-upload" type="file"
                                                                       onChange={this.onChange}
                                                                       style={{display: "none"}} accept="image/*"/>
                                                            </form>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td className="cell0"><p style={pStyle}>&nbsp;Data Source&nbsp;&nbsp;</p>
                                            </td>
                                            <td className="cell1">
                          <textarea name="TextArea1" id="TextArea1"
                                    ref={abc => this.child = abc}
                                    defaultValue={(objeler.ElementProps || {}).DataSource || ""}
                                    onChange={e => { if(objeler.ElementProps) objeler.ElementProps.DataSource = e.target.value; }}
                                    style={dataSourceStyle} rows="1" cols="20" spellCheck="false">
                          </textarea>
                                            </td>
                                            <td className="cell0"><p style={pStyle}>&nbsp;Condition&nbsp;&nbsp;</p></td>
                                            <td className="cell1">
                          <textarea name="TextArea1" id="TextArea1"
                                    ref={abc => this.child = abc}
                                    defaultValue={(objeler.ElementProps || {}).Condition || ""}
                                    onChange={e => { if(objeler.ElementProps) objeler.ElementProps.Condition = e.target.value; }}
                                    style={conditionStyle} rows="1" cols="20" spellCheck="false">
                          </textarea>
                                            </td>
                                        </React.Fragment>
                                    );
                            }
                        }).call(this)}
                    </tr>
                    {type === "Picture" && (
                        <tr>
                            <td className="cell1" colSpan="6">
                                <StructuredBindingPanel
                                    kind="image"
                                    binding={(objeler.ElementProps || {}).binding || (objeler.ElementProps || {}).Object?.binding || (objeler.ElementProps || {}).Object?.properties?.binding}
                                    onBindingChange={this.onStructuredBindingChange}
                                />
                            </td>
                        </tr>
                    )}
                    {(() => {
                        switch (type) {
                            case "Signature":
                                return (
                                    <React.Fragment>
                                        <tr>
                                            <td className="cell0"><p style={pStyle}>Color:</p></td>
                                            <td className="cell5">
                                                <Colorpicker color={prp&&prp.Object&&prp.Object.properties&&prp.Object.properties.colors ? prp.Object.properties.colors.color : "#000000"}
                                                             onChangeCompleted={this.changeColor}/>
                                            </td>
                                            <td className="cell0"><p style={pStyle}>&nbsp; Certificate File </p></td>
                                            <td className="cell7">
                                                <table
                                                    style={{border: "1px"}, {borderStyle: "solid"}, {borderColor: "black"}}
                                                    id="Table1">
                                                    <tbody>
                                                    <tr>
                                                        <td className="cell1" style={{height: "10px"}}>
                                                            <input id="certFile" className="form-control" type="text"
                                                                   readOnly="true" style={fileTextStyle}
                                                                   value={(objeler.ElementProps || {}).CertFileName || ""}
                                                            />
                                                        </td>
                                                        <td className="cellbtn" style={{height: "10px"}}>
                                                            <form onSubmit={this.onFormSubmit}>
                                                                <label htmlFor="file-upload-cert"
                                                                >
                                                                    <Button variant="raised" component="span"
                                                                            style={{width: '5em', paddingLeft: '.75em'}}
                                                                            className={classes.browseButton}
                                                                    >Browse </Button>
                                                                </label>
                                                                <input id="file-upload-cert" type="file"
                                                                       onChange={this.onChangeCert}
                                                                       style={{display: "none"}} accept=".pfx"/>
                                                            </form>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="cell0"><p style={pStyle}>Font :</p></td>
                                            <td className="cell1">
                                                <table>
                                                    <tbody>
                                                    <tr>
                                                        <td className="cell1" colSpan="2">
                                                            <p>
                                                                <ComboBox onChange={e => this.onFontChage(e)}
                                                                          comboStyle={comboStyle}
                                                                          comboValue={(objeler.ElementProps || {}).Font || "Arial"}
                                                                          items={fontItems}
                                                                />
                                                            </p>
                                                        </td>
                                                        <td className="cell1">
                                                            <input name="TextArea1" id="TextArea1"
                                                                   type="number"
                                                                   onKeyDown={e => e.preventDefault()}
                                                                   min="1" max="50 " style={fontSizeStyle}
                                                                   onChange={e => this.onFontSizeChage(e)}
                                                                   value={(objeler.ElementProps || {}).FontSize || 12}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="cell1Top">
                                                            <div id="wb_Checkbox1">
                                                                <input type="checkbox" id="chkBold" name=""
                                                                       style={{display: "inline-block"}}
                                                                       onChange={e => this.onChangeBold(e)}
                                                                       defaultChecked={(objeler.ElementProps || {}).Bold || false}/>
                                                                <label htmlFor="Checkbox1"
                                                                       style={{left: "60px"}, {float: "right"}, {position: "absolute"}, {fontWeight: "bold"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bold</label>
                                                            </div>
                                                        </td>
                                                        <td className="cell1Top">
                                                            <div id="wb_Checkbox1">
                                                                <input type="checkbox" id="chkItalic" name=""
                                                                       style={{display: "inline-block"}}
                                                                       onChange={e => this.onChangeItalic(e)}
                                                                       defaultChecked={(objeler.ElementProps || {}).Italic || false}/>
                                                                <label htmlFor="Checkbox1"
                                                                       style={{left: "60px"}, {float: "right"}, {position: "absolute"}, {fontStyle: "italic"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Italic</label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td className="cell0">
                                                <p style={pStyle}>&nbsp;Password</p>
                                            </td>
                                            <td className="cell1"><input name="TextArea1" id="TextArea1" type="password"
                                                                         autoComplete="off"
                                                                         defaultValue={(objeler.ElementProps || {}).Password || ""}
                                                                         onChange={this.onPasswordChage}
                                                                         style={textStyle} rows="1" cols="20"
                                                                         spellCheck="false">
                                            </input></td>
                                        </tr>
                                        <tr>
                                            <td className="cell0"><p style={pStyle}>Font :</p></td>
                                            <td className="cell1"><p style={pStyle}>
                                            </p></td>
                                            <td className="cell0"><p style={pStyle}>&nbsp;</p></td>
                                            <td className="cell1"><p style={pStyle}>&nbsp;</p></td>
                                        </tr>
                                    </React.Fragment>)
                            case "Lines":
                            case "Rectangle":
                            case "Ellipse":
                                return (
                                    < React.Fragment>
                                    </React.Fragment>
                                )
                            default:
                                return (
                                    <React.Fragment>
                                    </React.Fragment>
                                );
                        }
                    }).call(this)}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withStyles(DialogStyles)(PictureProperties);
